import { render, staticRenderFns } from "./graph-metric-bar.vue?vue&type=template&id=5b472dfa&scoped=true&"
import script from "./graph-metric-bar.vue?vue&type=script&lang=js&"
export * from "./graph-metric-bar.vue?vue&type=script&lang=js&"
import style0 from "./graph-metric-bar.vue?vue&type=style&index=0&id=5b472dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b472dfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
